import { ChevronLeft, ChevronRight, Pause, Play, X } from "lucide-react";
import "./AudioBriefing.css";

/**
 * Persistent mini-player for the hands-free audio briefing. The auto-advancing speech lives in
 * App (effect-driven); this is the visible control surface: now-playing, play/pause, skip, speed,
 * and close. Shown while a briefing session is open (even when paused). House style: no em dashes.
 */
export default function AudioBriefing({
  title,
  folio,
  speaking,
  rate,
  onPlayPause,
  onPrev,
  onNext,
  onCycleRate,
  onClose,
}: {
  title: string;
  /** Edition position line, e.g. "Story 03 of 10" (ties the player to the folio). */
  folio?: string;
  speaking: boolean;
  rate: number;
  onPlayPause: () => void;
  onPrev: () => void;
  onNext: () => void;
  onCycleRate: () => void;
  onClose: () => void;
}) {
  const rateLabel = rate === 1 ? "1x" : `${rate}x`;
  return (
    <div className={`audio-briefing${speaking ? " playing" : ""}`} role="region" aria-label="Audio briefing">
      <span className="ab-viz" aria-hidden="true"><i /><i /><i /><i /></span>
      <div className="ab-meta">
        <span className="ab-eyebrow">{speaking ? "Now reading" : "Paused"}{folio ? ` · ${folio}` : ""}</span>
        <span className="ab-title">{title}</span>
      </div>
      <div className="ab-controls">
        <button type="button" className="ab-btn" onClick={onPrev} aria-label="Previous story"><ChevronLeft size={18} /></button>
        <button type="button" className="ab-btn ab-play" onClick={onPlayPause} aria-label={speaking ? "Pause" : "Play"}>
          {speaking ? <Pause size={18} /> : <Play size={18} />}
        </button>
        <button type="button" className="ab-btn" onClick={onNext} aria-label="Next story"><ChevronRight size={18} /></button>
        <button type="button" className="ab-rate" onClick={onCycleRate} aria-label={`Playback speed ${rateLabel}, tap to change`}>{rateLabel}</button>
        <button type="button" className="ab-btn ab-close" onClick={onClose} aria-label="Close audio briefing"><X size={16} /></button>
      </div>
    </div>
  );
}
